import { render, staticRenderFns } from "./TransferRateForm.vue?vue&type=template&id=5e23dd5c"
import script from "./TransferRateForm.vue?vue&type=script&lang=js"
export * from "./TransferRateForm.vue?vue&type=script&lang=js"
import style0 from "./TransferRateForm.vue?vue&type=style&index=0&id=5e23dd5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports